import { useEffect } from "react";

import { useRefCallback, useRemembered } from "@mywheels/common/util";

export function useKeyDown(
  key: string | string[],
  onKeyDown?: (e: KeyboardEvent) => void,
  {
    enableAlsoWhenEditing = false,
    enableAlsoWithModifiers = false,
  }: {
    enableAlsoWhenEditing?: boolean;
    enableAlsoWithModifiers?: boolean;
  } = {}
) {
  const _onKeyDown = useRefCallback(onKeyDown);

  key = useRemembered(key);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // console.log(e.isComposing, e.ctrlKey, e.metaKey, e.altKey);
      if (e.isComposing || e.keyCode === 229) {
        return;
      }

      if (!enableAlsoWithModifiers && (e.ctrlKey || e.metaKey || e.altKey)) {
        return;
      }

      if (
        !enableAlsoWhenEditing &&
        e.target &&
        e.target instanceof HTMLElement &&
        e.target.matches("input, textarea")
      ) {
        return;
      }

      if (typeof key === "string" ? e.key === key : key.includes(e.key)) {
        return _onKeyDown(e);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [key, _onKeyDown, enableAlsoWhenEditing, enableAlsoWithModifiers]);
}
